import type { IAccount } from "@apis/accounts/types"
import { formatDate, formatRate, formatCurrency } from "@utils/formatters"

export const useAccountInvoicesSerializer = (accountData: IAccount) => {
  const native_unit_of_measure = accountData.utility_native_unit_of_measure

  const calculatePriceDifference = (
    calc_total_amt: number | null,
    usage_total_num: number | null,
    rate: string | undefined,
  ) => {
    if (usage_total_num == null || rate == null || calc_total_amt == null)
      return null

    return calc_total_amt - Number(rate) * usage_total_num
  }

  const data = accountData.invoices.map((invoice) => {
    return {
      ...invoice,
      charge_dt_formatted: formatDate(invoice.charge_dt),
      raw_invoiced_rate_formatted:
        invoice.raw_invoiced_rate && `$${invoice.raw_invoiced_rate}`,
      usage_days_cnt_formatted: `${invoice.usage_days_cnt} days`,
      usage_total_num_formatted: `${invoice.usage_total_num} ${native_unit_of_measure}`,
      usage_prev_month_diff_formatted: `${invoice.usage_prev_month_diff} ${native_unit_of_measure}`,
      usage_prev_month_percent_diff_formatted: `${invoice.usage_prev_month_diff}%`,
      calc_price_amt_formatted: formatCurrency(invoice.calc_price_amt, 2),
      price_tax_amt_formatted: formatCurrency(invoice.price_tax_amt, 2),
      calc_total_amt_formatted: formatCurrency(invoice.calc_total_amt, 2),

      price_to_compare_rate_formatted:
        invoice.price_to_compare?.rate && `$${invoice.price_to_compare?.rate}`,
      price_difference_formatted: formatCurrency(
        calculatePriceDifference(
          invoice.calc_total_amt,
          invoice.usage_total_num,
          invoice.price_to_compare?.rate,
        ),
        2,
      ),
      adjustment_amt_formatted: formatCurrency(invoice.adjustment_amt, 2),
      avg_rate_formatted: formatRate(
        invoice.avg_rate,
        accountData.utility_native_unit_of_measure,
      ),
    }
  })

  return data
}
